// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal-module--overlay--1XmiE","modal":"modal-module--modal--3Afi6","timeoutModal":"modal-module--timeoutModal--2_ZoP"};